import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";

import logo from "../../../public/images/logo/logo.png";
import logoLight from "../../../public/images/dark/logo/logo-light.png";

import Nav from "../Nav";
import HeaderRightTwo from "../Header-Right/HeaderRight-Two";
import { useAppContext } from "@/context/Context";

const HeaderNine = ({
  gapSpaceBetween,
  transparent,
  navigationEnd,
  headerType,
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const { isLightTheme } = useAppContext();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      if (scrolled > 180) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <div
        className={`rbt-header-wrapper ${gapSpaceBetween} ${transparent} ${
          !headerType && isSticky ? "rbt-sticky" : ""
        }`}
      > 
        <div className="container pt-lg-3 pt-0 pb-lg-3 pb-0">
          <div className={`mainbar-row ${navigationEnd} align-items-center`}>
            <div className="header-left rbt-header-content">
              <div className="header-info">
                <div className="logo">
                  <Link href="/">
                    {isLightTheme ? (
                      <Image
                        src={logo}
                        width={152}
                        height={50}
                        priority={true}
                        alt="Education Logo Images"
                      />
                    ) : (
                      <Image
                        src={logo}
                        width={152}
                        height={50}
                        priority={true}
                        alt="Education Logo Images"
                      />
                    )}
                  </Link>
                </div>
              </div>
            </div>

            {/* <div className="rbt-main-navigation d-none d-xl-block">
              <Nav />
            </div> */}
            <HeaderRightTwo
              userType="Admin"
              btnText="Enroll Now"
              btnClass=" btn-border-gradient radius-round btn-sm hover-transform-none"
            />
          </div>
        </div>

        {/* <Search /> */}
      </div>
    </>
  );
};

export default HeaderNine;
